import * as React from 'react'
import { FC } from 'react'

import { DeleteSalesTeamFormWrapper } from './DeleteSalesTeamFormWrapper'
import { Dialog, DialogBody } from '@sales-center/components'
import { ISalesTeam } from '@user/store/salesTeam/typings'

interface Props {
  salesTeam: ISalesTeam
  onClose: () => void
  onDelete: (id: string) => void
  open: boolean
}

export const DeleteSalesTeamDialog: FC<Props> = (props: Props) => {
  const { onClose, onDelete, open, salesTeam } = props

  return (
    <Dialog
      onClose={onClose}
      open={open}
      title={`Delete Sales Team`}
      width="sm"
    >
      <DialogBody>
        <DeleteSalesTeamFormWrapper
          onClose={onClose}
          onDelete={onDelete}
          salesTeam={salesTeam}
        />
      </DialogBody>
    </Dialog>
  )
}

DeleteSalesTeamDialog.displayName = 'DeleteSalesTeamDialog'
